import React from "react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_admin-dashboard-cafe/artifacts/lm6yrhpy_Product%402x.png";

export default function BrandLogo({ size = 36, className = "", ring = false }) {
  return (
    <img
      src={LOGO_URL}
      alt="Mirrorloops"
      style={{ width: size, height: size }}
      className={`object-contain ${ring ? "rounded-lg ring-1 ring-[#D4B878]/20 bg-[#0A0908] p-1" : ""} ${className}`}
    />
  );
}
